import React from "react";

const AggressionHistory = ({ formData, handleChange, setActiveTab, selectedProgram, errors = {}, onNext }) => {
    return (
        <div id="aggression-history" className="content">
            <div className="row g-3 justify-content-center">
                <div className="col-md-12">
                    {/* --- Previous Episode (Yes/No) --- */}
                    <div className="mb-3">
                        <small className="text-dark bg-primary-subtle rounded-4 fw-bold d-block mb-3">
                            Previous episode of aggression/violence
                        </small>
                        <div className="checkbox-group d-flex justify-content-center">
                            {["Yes", "No"].map((option) => {
                                const inputId = `prev_aggression-${option}`;
                                return (
                                    <div className="form-check form-check-inline" key={option}>
                                        <input
                                            className="form-check-input"
                                            type="radio"
                                            name="prev_aggression"
                                            id={inputId}
                                            value={option}
                                            checked={formData.prev_aggression === option}
                                            onChange={handleChange}
                                        />
                                        <label className="form-check-label" htmlFor={inputId}>
                                            {option}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                        {errors.prev_aggression && (
                            <small className="text-danger d-block text-center mt-2">{errors.prev_aggression}</small>
                        )}
                    </div>

                    {/* --- 2x2 Question Grid --- */}
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">When was the last episode?</label>
                            <input
                                type="text"
                                className={`form-control ${errors.last_episode ? 'is-invalid' : ''}`}
                                name="last_episode"
                                value={formData.last_episode || ""}
                                onChange={handleChange}
                            />
                            {errors.last_episode && (
                                <div className="invalid-feedback">{errors.last_episode}</div>
                            )}
                        </div>
                        <div className="col-md-6">
                            <label className="form-label">Was the incident provoked?</label>
                            <div className="checkbox-group d-flex justify-content-center">
                                {["Yes", "No"].map((option) => {
                                    const inputId = `incident_provoked-${option}`;
                                    return (
                                        <div className="form-check form-check-inline" key={option}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="incident_provoked"
                                                id={inputId}
                                                value={option}
                                                checked={formData.incident_provoked === option}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor={inputId}>
                                                {option}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                            {errors.incident_provoked && (
                                <small className="text-danger d-block text-center mt-2">{errors.incident_provoked}</small>
                            )}
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="form-label">Does he/she regret the incident?</label>
                            <div className="checkbox-group d-flex justify-content-center">
                                {["Yes", "No"].map((option) => {
                                    const inputId = `regret_incident-${option}`;
                                    return (
                                        <div className="form-check form-check-inline" key={option}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="regret_incident"
                                                id={inputId}
                                                value={option}
                                                checked={formData.regret_incident === option}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor={inputId}>
                                                {option}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                            {errors.regret_incident && (
                                <small className="text-danger d-block text-center mt-2">{errors.regret_incident}</small>
                            )}
                        </div>

                        <div className="col-md-6">
                            <label className="form-label">Does he/she show denial?</label>
                            <div className="checkbox-group d-flex justify-content-center">
                                {["Yes", "No"].map((option) => {
                                    const inputId = `show_denial-${option}`;
                                    return (
                                        <div className="form-check form-check-inline" key={option}>
                                            <input
                                                className="form-check-input"
                                                type="radio"
                                                name="show_denial"
                                                id={inputId}
                                                value={option}
                                                checked={formData.show_denial === option}
                                                onChange={handleChange}
                                            />
                                            <label className="form-check-label" htmlFor={inputId}>
                                                {option}
                                            </label>
                                        </div>
                                    );
                                })}
                            </div>
                            {errors.show_denial && (
                                <small className="text-danger d-block text-center mt-2">{errors.show_denial}</small>
                            )}
                        </div>
                    </div>

                    {/* --- Describe Episode --- */}
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className={`form-control ${errors.episode_description ? 'is-invalid' : ''}`}
                            name="episode_description"
                            value={formData.episode_description || ""}
                            onChange={handleChange}
                            placeholder="Describe episode briefly"
                            style={{ height: "120px" }}
                        />
                        <label>Please describe the episode briefly</label>
                        {errors.episode_description && (
                            <div className="invalid-feedback">{errors.episode_description}</div>
                        )}
                    </div>

                    {/* --- Cope with Stress --- */}
                    <div className="form-floating form-floating-outline mb-3">
                        <textarea
                            className={`form-control ${errors.cope_stress ? 'is-invalid' : ''}`}
                            name="cope_stress"
                            value={formData.cope_stress || ""}
                            onChange={handleChange}
                            placeholder="How does the client handle stress?"
                            style={{ height: "120px" }}
                        />
                        <label>How does the client generally handle/copes with stress</label>
                        {errors.cope_stress && (
                            <div className="invalid-feedback">{errors.cope_stress}</div>
                        )}
                    </div>
                </div>

                {/* --- Navigation --- */}
                <div className="col-12 d-flex justify-content-end mt-2">
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-outline-secondary btn-sm w-100"
                            onClick={() =>
                                setActiveTab(selectedProgram === "3" ? "physical-health" : "medications")
                            }
                        >
                            <i className="ri-arrow-left-line"></i> Previous
                        </button>
                    </div>
                    <div className="col-md-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm ms-2 w-100"
                            onClick={onNext}
                        >
                            Next <i className="ri-arrow-right-line"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AggressionHistory;